module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/life-pension-8c166777195f3669f054471d14e75a5a.png";